<template>
  <div class="relative">
    <cms-section
      :class="{ invisible: showSkeleton }"
      disable-lazy-hydrate
      :first-section="firstElement"
      :page-context
      :section="{ name: 'filter-by', items }"
    />
    <div v-if="showSkeleton" class="absolute-0 z-overlay skeleton" />
  </div>
</template>

<script lang="ts" setup>
import type { FilterByContent } from '#types/components/cms/filter-by'

const { content, firstElement, pageContext } = defineProps<{
  content: FilterByContent
  firstElement?: boolean
  pageContext?: boolean
  fullHeight?: boolean
}>()

const route = useRoute()
const pdpData = usePdp()

const { cartItems: resolvedCartItems, showSkeleton } = useSsrSafeFilterState(hasByCartFilter(content.filters))

const items = computed(() => filterContentBy(content, {
  route,
  attributes: pdpData?.product.value?.contentAttributes,
  cartItems: resolvedCartItems.value
}))
</script>
